import React from "react";
import Grid from "material-ui/Grid";
import Typography from "material-ui/Typography";
import Paper from "material-ui/Paper";
import Button from "material-ui/Button";
import Icon from "material-ui/Icon";
import Tooltip from "material-ui/Tooltip";
import { Link } from "react-router-dom";
import {
  FormControl,
  FormHelperText,
  FormControlLabel,
  FormGroup
} from "material-ui/Form";
import Switch from "material-ui/Switch";
import ButtonBase from "material-ui/ButtonBase";

import { withStyles } from "material-ui/styles";
import styles from "./styles";

import JobProgress from "./jobProgress";

import { dateFormatter, isVDVType,isSignalTEKQTType, isNaviTEKType } from "../../../common/utils";
class JobHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      errors: {},
      tabs: [
        props.translate("job_details"),
        props.translate("job_metadata"),
        props.translate("job_settings")
      ],
      tabPosition: 0,
      job: {
        publish: false,
        status: false,
        enablesync: true,
        enableJobComplete: false,
        name: "",
        deviceid: props.prevSelectedDeviceid ? props.prevSelectedDeviceid : "",
        customerid: "",
        metadatalookupid: "",
        metadataStandardCustom: {
          6: { enabled: false, value: "" },
          5: { enabled: false, value: "" },
          4: { enabled: false, value: "" },
          3: { enabled: false, value: "" },
          2: { enabled: false, value: "" },
          1: { enabled: false, value: "" }
        }
      },
      customer: {
        name: "",
        address: "",
        contactemail: "",
        telephoneno: "",
        contact: "",
        city: "",
        state: "",
        country: "",
        zipcode: ""
      },
      mode: "create",
      showDeviceTypes: true,
      disableJobIdentifiers: false
    };
  }

  onToggleChange = (e, checked, job) => {
    if (job.deviceid) {
      job[e.target.name] = checked;
      this.setState({ job: job });
      this.props.onSyncChange(job.id);
    }
  };

  render() {
    const {
      translate,
      classes,
      job,
      edit,
      del,
      reportGen,
      attachments,
      view,
      jobReload,
      downloadCsv,
      rengernateImage,
      imageGenerationFailed,
      // selected,
      totalSelected,
      isSelectionShow,
      title,
      exportJob,
      downloadExportedJob
    } = this.props;

    let disableControlButtons = false;
    if (job && job.pendingcount) {
      disableControlButtons = true;
    }
    const isCometJob =
      job && job.deviceid
        ? ["comet_copper", "comet_fiber"].includes(job.deviceid)
        : false;
    const isMobileJob = job && isVDVType(job.deviceid);
    const isSignalTEKQtJob = job && isSignalTEKQTType(job.deviceid);
    const isNaviTEKJob = job && isNaviTEKType(job.deviceid);
    return (
      <Paper className={classes.paper}>
        <Grid container className={classes.removeMargin}>
          <Grid item xs={4} className={classes.jobsHeader}>
            <ButtonBase
              className={classes.jobHeaderDetails}
              component={Link}
              to={`/job/${job.id}`}
            >
              <Grid className={classes.jobHeaderDetails}>
                <Typography type="title">{job.name}</Typography>
                <Typography type="subheading" className={classes.jobDate}>
                  {dateFormatter(job.createdat)}
                </Typography>
                <div className={classes.innerjobDetails}>
                  <Typography type="subheading" className={classes.jobCustomer}>
                    {job.customer_name}
                  </Typography>
                  <Typography type="subheading" className={classes.jobDate}>
                    {isMobileJob ? translate("vdviipoepro") : 
                      isSignalTEKQtJob ? translate("signaltekqtorpro") :
                        isNaviTEKJob ? translate("navitekorpro") :
                          job.deviceid
                          ? translate(job.deviceid)
                          : translate("lantekIII")}
                  </Typography>
                </div>
              </Grid>
            </ButtonBase>

            {view !== undefined && (
              <Grid item className={classes.jobFunctions}>
                {(edit !== undefined) && (
                  <Tooltip
                    title={translate("tooltip_edit")}
                    disableTriggerFocus={true}
                  >
                    <Button
                      aria-label="Edit"
                      mini
                      onClick={e => edit(e, job)}
                      id={job.id}
                      className={classes.jobcardButtons}
                      disabled={disableControlButtons}
                    >
                      <Icon color={"primary"}>edit</Icon>
                    </Button>
                  </Tooltip>
                )}
                {reportGen !== undefined && (
                  <Tooltip
                    title={translate("tooltip_create_report")}
                    disableTriggerFocus={true}
                  >
                    <Button
                      aria-label="Create Report"
                      mini
                      onClick={e => reportGen(e, job)}
                      id={job.id}
                      className={classes.jobcardButtons}
                      disabled={disableControlButtons}
                    >
                      <Icon color={"primary"}>insert_drive_file</Icon>
                    </Button>
                  </Tooltip>
                )}
                {attachments !== undefined && (
                  <Tooltip
                    title={translate("tooltip_attach_files")}
                    disableTriggerFocus={true}
                  >
                    <Button
                      aria-label="Attach Files"
                      mini
                      onClick={e => attachments(e, job)}
                      id={job.id}
                      className={`${classes.jobcardButtons} ${
                        job && job.attachmentexists
                          ? classes.attachmentExists
                          : ""
                      }`}
                      disabled={disableControlButtons}
                    >
                      <Icon>attach_file</Icon>
                    </Button>
                  </Tooltip>
                )}
                {del !== undefined && (
                  <Tooltip
                    title={translate("tooltip_delete")}
                    disableTriggerFocus={true}
                  >
                    <Button
                      aria-label="Delete"
                      mini
                      onClick={e => del(e, job)}
                      id={job.id}
                      className={classes.jobcardButtons}
                      disabled={disableControlButtons}
                    >
                      <Icon color={"primary"}>delete</Icon>
                    </Button>
                  </Tooltip>
                )}
                <Tooltip
                  title={translate("tooltip_download_csv")}
                  disableTriggerFocus={true}
                >
                  <Button
                    aria-label="Download"
                    mini
                    onClick={() => downloadCsv(job.id, job.name)}
                    id={job.id}
                    className={classes.jobcardButtons}
                    disabled={disableControlButtons}
                  >
                    <Icon color={"primary"}>
                      <img
                        height="18px"
                        width="18px"
                        src={"/images/labelroll.svg"}
                      />
                    </Icon>
                  </Button>
                </Tooltip>
                {((imageGenerationFailed &&
                  imageGenerationFailed.showImageReGenerate &&
                  imageGenerationFailed.imageFailedJobId === job.id) ||
                  job.imagefailed) && (
                  <Tooltip
                    title={translate("regenerate_image")}
                    disableTriggerFocus={true}
                  >
                    <Button
                      aria-label="REGENERATEIMAGE"
                      mini
                      onClick={() => rengernateImage(job.id)}
                      id={job.id}
                      className={classes.jobcardButtons}
                    >
                      <Icon color={"primary"}>image</Icon>
                    </Button>
                  </Tooltip>
                )}
                {job.deviceid && !isMobileJob ? (
                  <Tooltip
                    title={
                      disableControlButtons
                        ? ""
                        : job.enablesync
                        ? translate("job_disablesync")
                        : translate("job_enablesync")
                    }
                    disableTriggerFocus={true}
                  >
                    <FormGroup className={classes.syncButton}>
                      <FormControlLabel
                        control={
                          <Switch
                            name="enablesync"
                            checked={job.enablesync}
                            onChange={(e, checked) =>
                              this.onToggleChange(e, checked, job)
                            }
                            disabled={disableControlButtons}
                            classes={{
                              root: classes.toggle,
                              bar: classes.toggleBar,
                              checked: classes.toggleOn
                            }}
                          />
                        }
                      />
                    </FormGroup>
                  </Tooltip>
                ) : null}

                {isCometJob ? (
                  !(
                    ["in_progress"].includes(job.exportstatus) ||
                    disableControlButtons
                  ) ? (
                    <Tooltip
                      title={
                        disableControlButtons
                          ? ""
                          : job.exportstatus == "failed"
                          ? translate("tooltip_export_job_failed")
                          : job.exportstatus == "in_progress"
                          ? translate("tooltip_export_job_in_progress")
                          : translate("export_job")
                      }
                      disableTriggerFocus={true}
                    >
                      <Button
                        aria-label="EXPORTJOB"
                        mini
                        onClick={e => exportJob(e, job, "export")}
                        id={job.id}
                        className={classes.jobcardButtons}
                      >
                        <Icon color={"primary"}>import_export</Icon>
                      </Button>
                    </Tooltip>
                  ) : (
                    <Tooltip
                      title={
                        disableControlButtons
                          ? ""
                          : job.exportstatus == "failed"
                          ? translate("tooltip_export_job_failed")
                          : job.exportstatus == "in_progress"
                          ? translate("tooltip_export_job_in_progress")
                          : translate("export_job")
                      }
                      disableTriggerFocus={true}
                    >
                      <span className={classes.exportIcon}>
                        <Button
                          aria-label="EXPORTJOB"
                          mini
                          onClick={e => exportJob(e, job, "export")}
                          id={job.id}
                          className={classes.jobcardButtons}
                          disabled={
                            ["in_progress"].includes(job.exportstatus) ||
                            disableControlButtons
                          }
                        >
                          <Icon color={"primary"}>import_export</Icon>
                        </Button>
                      </span>
                    </Tooltip>
                  )
                ) : null}

                {isCometJob && job.exported ? (
                  !(
                    ["failed", "in_progress"].includes(job.exportstatus) ||
                    disableControlButtons
                  ) ? (
                    <Tooltip
                      title={
                        disableControlButtons ||
                        ["failed", "in_progress"].includes(job.exportstatus)
                          ? ""
                          : translate("download_job")
                      }
                      disableTriggerFocus={true}
                    >
                      <Button
                        aria-label="DOWNLOADEXPORTJOB"
                        mini
                        onClick={e => downloadExportedJob(e, job, "download")}
                        id={job.id}
                        className={classes.jobcardButtons}
                      >
                        <Icon color={"primary"}>file_download</Icon>
                      </Button>
                    </Tooltip>
                  ) : (
                    <Tooltip
                      title={
                        disableControlButtons ||
                        ["failed", "in_progress"].includes(job.exportstatus)
                          ? ""
                          : translate("download_job")
                      }
                      disableTriggerFocus={true}
                    >
                      <span className={classes.exportIcon}>
                        <Button
                          aria-label="DOWNLOADEXPORTJOB"
                          mini
                          onClick={e => downloadExportedJob(e, job, "download")}
                          id={job.id}
                          className={classes.jobcardButtons}
                          disabled={
                            ["failed", "in_progress"].includes(
                              job.exportstatus
                            ) || disableControlButtons
                          }
                        >
                          <Icon color={"primary"}>file_download</Icon>
                        </Button>
                      </span>
                    </Tooltip>
                  )
                ) : null}
              </Grid>
            )}
          </Grid>
          <Grid item xs={8} className={classes.jobCardRight}>
            <ButtonBase
              className={classes.buttonBase}
              component={Link}
              to={`/job/${job.id}`}
            >
              <Grid item xs={12}>
                <Grid
                  container
                  direction="row"
                  justify="flex-start"
                  alignItems="center"
                  className={classes.jobTotals}
                >
                  <Grid item xs={4} md={3} className={classes.totalGrid}>
                    <Typography
                      type="body1"
                      className={classes.totalText}
                      align="center"
                    >
                      {translate("job_header_total")}
                    </Typography>
                    <Typography
                      type="display1"
                      className={classes.totalText}
                      align="center"
                      gutterBottom
                    >
                      {job.totaltest}
                    </Typography>
                  </Grid>
                  <Grid item xs={4} md={3} className={classes.passedGrid}>
                    <Typography
                      type="body1"
                      className={classes.passedText}
                      align="center"
                    >
                      {translate("job_header_passed")}
                    </Typography>
                    <Typography
                      type="display1"
                      className={classes.passedText}
                      align="center"
                      gutterBottom
                    >
                      {job.passedtest}
                    </Typography>
                  </Grid>
                  <Grid item xs={4} md={3} className={classes.failedGrid}>
                    <Typography
                      type="body1"
                      className={classes.failedText}
                      align="center"
                    >
                      {translate("job_header_failed")}
                    </Typography>
                    <Typography 
                      type="display1"
                      className={classes.failedText}
                      align="center"
                      gutterBottom
                    >
                      {job.failedtest}
                    </Typography>
                  </Grid>
                  {isSelectionShow && (
                    <Grid item xs={4} md={3} className={classes.selectedGrid}>
                      <Typography
                        type="body1"
                        className={classes.passedText}
                        align="center"
                      >
                        {translate("job_header_selected")}
                      </Typography>
                      <Typography
                        type="display1"
                        className={classes.passedText}
                        align="center"
                        gutterBottom
                      >
                        {totalSelected}
                      </Typography>
                    </Grid>
                  )}
                </Grid>

                <Grid container>
                  <Grid item xs={12} className={classes.progressBar}>
                    <JobProgress
                      total={job.totaltest}
                      pass={job.passedtest}
                      fail={job.failedtest}
                    />
                  </Grid>
                </Grid>
              </Grid>
              {view !== undefined && (
                <Button className={classes.viewJob} color="accent" raised mini>
                  {translate ? translate("general_view") : "View"}
                </Button>
              )}
            </ButtonBase>
            {disableControlButtons && (
              <span>
                <span className={classes.jobStatus}>
                  {`${translate("uploaded_tests_pending_process_count")}: ${
                    job.pendingcount
                  }`}
                </span>
                {title && title == "jobspage" && (
                  <Tooltip
                    title={translate("tooltip_reload")}
                    disableTriggerFocus={true}
                  >
                    <Button
                      aria-label="Reload"
                      mini
                      onClick={() => jobReload(job.id)}
                      id={job.id}
                      className={classes.reloadButton}
                    >
                      <Icon color={"primary"}>refresh</Icon>
                    </Button>
                  </Tooltip>
                )}
              </span>
            )}
          </Grid>
        </Grid>
      </Paper>
    );
  }
}

export default withStyles(styles)(JobHeader);



// WEBPACK FOOTER //
// ./src/components/common/jobs/jobHeader.js